// Filename and date formatting helpers for PDF export.

export const sanitizeFilename = (title: unknown): string =>
  String(title ?? '')
    .replace(/[^\p{L}\p{N}\s-]/gu, '')
    .replace(/\s+/g, '_')
    .substring(0, 50);

// YYYY-MM-DD_HHMM in the user's local timezone — shared between the visible
// "Exported by ... on ..." byline and the suggested filename.
export const formatExportedAt = (date: Date = new Date()): string => {
  const parts = Object.fromEntries(
    new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    })
      .formatToParts(date)
      .map(({ type, value }) => [type, value])
  );
  return `${parts.year}-${parts.month}-${parts.day}_${parts.hour}${parts.minute}`;
};

// No .pdf suffix — this becomes the iframe document.title and Chrome appends
// the extension itself when saving as PDF.
export const buildPdfFilename = (
  contentId: number,
  title: string,
  exportedAtStr: string
): string =>
  `${contentId}_${sanitizeFilename(title) || 'campaign'}_${exportedAtStr}`;
